var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('ol',{staticClass:"breadcrumb mb-0 p-0"},_vm._l((_vm.breadcrumbList),function(breadcrumb,index){return _c('li',{key:index,staticClass:"breadcrumb-item",class:{
        active: !!breadcrumb.link,
      },attrs:{"tabindex":"-1"}},[(breadcrumb.link)?_c('router-link',{attrs:{"to":{ name: breadcrumb.name, params: breadcrumb.params },"tabindex":"-1"}},[_vm._v(" "+_vm._s(breadcrumb.label)+" ")]):_c('span',{attrs:{"tabindex":"-1"}},[_vm._v(_vm._s(breadcrumb.label))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }